import makeRequest from 'makeRequest';
import {getToken} from 'helpers/getToken';

const validateVatNumber = async str => {
    const path = '/vat_validation';
    const authToken = getToken();
    try {
        return await makeRequest({path, data: {authToken, query: str}});
    } catch (error) {
        console.log(error);
        return null;
    }
};

export default validateVatNumber;
